import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchVendor, fetchVendors } from "services/vendor";

const VendorDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  setVendorDetails
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);
  const selectedVendorId = watch("vendor_id");

  const { data: vendors, isLoading, isError, error, refetch } = useQuery(
    ["fetch-vendors"],
    fetchVendors,
    { staleTime: DROPDOWN_STALE_TIME }
  );

  const { data: vendor } = useQuery(
    ["fetch-vendor-by-id", selectedVendorId],
    () => (selectedVendorId ? fetchVendor(selectedVendorId) : null),
    { staleTime: DROPDOWN_STALE_TIME, enabled: !!selectedVendorId }
  );

  if (setVendorDetails) {
    setVendorDetails(vendor?.data);
  }

  useEffect(() => {
    refetch();
  }, [login]);

  const options = useMemo(() => {
    return (
      vendors?.data?.data?.map((vendor) => ({
        value: vendor?.id,
        label: vendor?.vendor_name,
      })) || []
    );
  }, [vendors]);

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.vendor_id
      );
      setValue("vendor_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedVendorId
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading vendors</div>;

  return (
    <Controller
      name="vendor_id"
      control={control}
      rules={{
        required: required ? "Vendor is required" : false,
        validate: (value) => (required && !value ? "Vendor is required" : true),
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Vendor"
          value={selectedOption || null}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              height: "42px",
            }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("vendor_id", value);

            if (value) {
              fetchVendor(value);
            }
          }}
          className={`react-select-container ${errors.vendor_id ? "is-invalid" : ""}`}
        />
      )}
    />
  );
};

export default VendorDropDown;
